export const items = [
    {
        "image" : "slide1",
        "heading" : "Learn",
        "descrption" : "Join and have a great learning experience"
    },
    {
        "image" : "slide2",
        "heading" : "Design",
        "descrption" : "Think out of the box"
    },
    {
        "image" : "slide3",
        "heading" : "Innovate",
        "descrption" : "Join  and have a great learning experience"
    },
    {
        "image" : "slide",
        "heading" : "Electropix '23",
        "descrption" : "Next wave coming soon."
    }
]



